import { Box, Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';

const tabSx = {
  textTransform: 'none',
  minHeight: '40px',
  padding: '9px 16px',
  fontSize: '14px',
  fontWeight: 700,
  lineHeight: 1.57,
  letterSpacing: '0.1px',
} as const;

export function VerifyAssetsTabs() {
  const { t } = useTranslation(['periverse']);

  return (
    <Box sx={{ padding: '16px 24px 0' }} data-testid="verify-assets-tabs">
      <Tabs
        value={1}
        sx={{ minHeight: '40px', borderBottom: 1, borderColor: 'divider' }}
        aria-label={t('pages.caseVerifyAssets.tabs.label')}
      >
        <Tab
          label={t('pages.caseVerifyAssets.tabs.overview')}
          value={0}
          disabled
          sx={tabSx}
          data-testid="verify-assets-tab-overview"
        />
        <Tab
          label={t('pages.caseVerifyAssets.tabs.itemsAndEquipment')}
          value={1}
          sx={tabSx}
          data-testid="verify-assets-tab-items-and-equipment"
        />
      </Tabs>
    </Box>
  );
}
